var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-left flex-grid"},[(
      _vm.tagName === '主被保人' ||
      _vm.tagName === '要保人' ||
      _vm.tagName === '主約' ||
      _vm.tagName === '本人' ||
      _vm.tagName == '台幣'
    )?_c('div',[_c('div',{staticClass:"text-tag color-primary"},[_vm._v(_vm._s(_vm.tagName))])]):(
      _vm.tagName === '公告' ||
      _vm.tagName === '配偶' ||
      _vm.tagName === '子女' ||
      _vm.tagName === '法定繼承人' ||
      _vm.tagName === '父母' ||
      _vm.tagName === '兄弟姊妹' ||
      _vm.tagName === '附約' ||
      _vm.tagName === '外幣'
    )?_c('div',[_c('div',{staticClass:"text-tag color-secondary"},[_vm._v(_vm._s(_vm.tagName))])]):(
      _vm.tagName === '證照' ||
      _vm.tagName === '祖孫' ||
      _vm.tagName === '其他' ||
      _vm.tagName === '要賠人' ||
      _vm.tagName === '婦嬰'
    )?_c('div',[_c('div',{staticClass:"text-tag color-accent"},[_vm._v(_vm._s(_vm.tagName))])]):(_vm.tagName === '訊息公告')?_c('div',[_c('div',{staticClass:"text-tag color-green"},[_vm._v(_vm._s(_vm.tagName))])]):_c('div',[_c('div',{staticClass:"text-tag color-accent"},[_vm._v(_vm._s(_vm.tagName))])]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }